<template>
   <div>
    <div class="form-2-header-section">
    <div class="form-header-div">
      <div class="div-block-966">
        <a href="#" class="w-inline-block"><img sizes="(max-width: 2083px) 100vw, 2083px" srcset="@/assets/images/_Rx-Pros-Logo-01-p-500.png 500w, @/assets/images/_Rx-Pros-Logo-01-p-800.png 800w, @/assets/images/_Rx-Pros-Logo-01-p-1080.png 1080w, @/assets/images/_Rx-Pros-Logo-01.png 2083w" alt="" src="@/assets/images/_Rx-Pros-Logo-01.png" loading="lazy" class="image-30"></a>
        
      </div>
    </div>
    <div class="div-block-181">
      <div class="girl-div"></div>
    </div>
  </div>
  <section class="form2-section">
    <div class="form2-main-wrap"></div>
  </section>
  <div class="form-section _2" >
    <div class="questions-div" style="padding-top:0px;">
      <div class="question-container _2">
        <div class="question-category f2">
          <div class="enroll-form-header-text">CONGRATULATIONS</div>
        </div>
        <div class="question-div-2">
          <div class="div-block-1450 end">
            <div class="text-block-517">You Qualify, {{user.first_name}}!</div>
          </div>
          <div class="text-block-513 end bold">You are the perfect candidate for our Weight Loss Program.</div>
          
          <div class="div-block-1698" style="width: 100%;">
                  <div class="div-block-1674">
                    <div class="div-block-1696">
                      <div class="text-block-732">Your Current Weight is</div>
                      <div class="text-block-720">{{user.weight}} <span class="text-span-176">lbs</span></div>
                    </div>
                    <div class="div-block-1696">
                      <div class="text-block-732">Your Target Weight is</div>
                      <div class="text-block-720">{{desiredWeight}} <span class="text-span-176">lbs</span></div>
                    </div>
                  </div>
                </div>

          <div class="report-summary-div" style="width: 100%;">
            <div class="div-block-1685">
              <div class="div-block-1675">
                <div class="div-block-1695">
                  <div class="div-block-1689">
                    <div class="table-row-div-2 top">
                      <div class="div-block-1684">
                        <div class="text-block-723 top">Program</div>
                      </div>
                      <div class="div-block-1692">
                        <div class="text-block-723 top">% Loss</div>
                      </div>
                      <div class="div-block-1686">
                        <div class="text-block-723 top">Weight Loss</div>
                      </div>
                      <div class="div-block-1699">
                        <div class="text-block-723 top">New Weight</div>
                      </div>
                    </div>
                    <div class="table-row-div-2">
                      <div class="div-block-1684">
                        <div class="text-block-723">Avg. Weight Loss on Semaglutide</div>
                      </div>
                      <div class="div-block-1692">
                        <div class="text-block-716">16%</div>
                      </div>
                      <div class="div-block-1686">
                        <div class="text-block-716">{{ (parseInt(user.weight) * 0.16).toFixed(0) }} <span class="text-span-175">lbs</span></div>
                      </div>
                      <div class="div-block-1699">
                        <div class="text-block-716">{{ (parseInt(user.weight) - (parseInt(user.weight) * 0.16)).toFixed(0) }} <span class="text-span-175">lbs</span></div>
                      </div>
                    </div>
                    <div class="table-row-div-2">
                      <div class="div-block-1684">
                        <div class="text-block-723">Avg. Weight Loss on Tirzepatide</div>
                      </div>
                      <div class="div-block-1692">
                        <div class="text-block-716">22%</div>
                      </div>
                      <div class="div-block-1686">
                        <div class="text-block-716">{{ (parseInt(user.weight) * 0.22).toFixed(0) }} <span class="text-span-175">lbs</span></div>
                      </div>
                      <div class="div-block-1699">
                        <div class="text-block-716">{{ (parseInt(user.weight) - (parseInt(user.weight) * 0.22)).toFixed(0) }} <span class="text-span-175">lbs</span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="sticky-mobile-cta">
            <router-link to="/weight-loss-plan" class="button-65 finish w-button mobbutt" style="margin-bottom: 15px;">Start Your Weight Loss Journey <span class="text-span-177">-&gt;</span></router-link>
          </div>
           </div>
      </div>
      
    </div>
  </div>
   </div>
</template>

<script>

import {
    mapGetters
} from 'vuex';
export default {
    
    data() {
        return {
            scrollAmount: 225,
            desiredWeight:120,
            appName: process.env.VUE_APP_COMPANY,
            videos: []
        };
    },
    computed: {
        ...mapGetters([
            'user',
        ]),
        getYear() {
            return new Date().getFullYear();
        },
        isDiscountOffer() {
            return true;
        },
        
        
    },
    mounted() {
      if(this.$route.query.desiredWeight){
        this.desiredWeight = this.$route.query.desiredWeight;
      }
      
    },
    methods: {
        getDetails() {
            this.people.first_name = this.$route.query.name;
            this.people.weight = this.$route.query.weight;
            this.people.desired_weight = this.$route.query.goal;
        },
        handleTouchStart(event) {
            this.startX = event.touches[0].clientX;
        },
        handleTouchMove(event) {
            this.currentX = event.touches[0].clientX;
        },
        handleTouchEnd() {
            const deltaX = this.currentX - this.startX;
            if (Math.abs(deltaX) > 50) {
                if (deltaX > 0) {
                    this.scrollLeft();
                } else {
                    this.scrollRight();
                }
            }
        },
        scrollLeft() {
            const container = this.$refs.carouselContent;
            container.scrollBy({
                left: -this.scrollAmount,
                behavior: 'smooth'
            });
        },
        scrollRight() {
            const container = this.$refs.carouselContent;
            container.scrollBy({
                left: this.scrollAmount,
                behavior: 'smooth'
            });
        },
        
        
        scrolltoTop() {
            setTimeout(function () {
                window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            }, 100);
        },
    },
    created() {
        this.scrolltoTop();

    }
};
</script>
<style scoped>
@media (max-width: 768px) {
  .sticky-mobile-cta {
    position: fixed;
    bottom: 1px; /* Optional: adds spacing from bottom */
    left: 50%;
    height:auto;
    transform: translateX(-50%);
    width: 100%;
    z-index: 999;
    text-align: center; /* Optional: centers text if needed */
    background-color: #fff !important; /* Add this */
    padding: 10px 0; /* Add padding to make background visible */
  }
  .mobbutt{
    width: 90%;
  }
}
.text-block-1115{
  background-image: none;
}
.text-block-573{
  background-color: transparent;
}
</style>